
import { of, Observable } from 'rxjs';
import { catchError, map, share, switchMap } from 'rxjs/operators';
import { Injectable } from '@angular/core';
import { Actions, Effect, ofType } from '@ngrx/effects';
import { AveragePriceApiService } from '../../services/average-price/stocks-api.service';
import { AveragePriceAction } from './average-price.action';

@Injectable()
export class AveragePriceEffects {

    /**
     * Busca o preço médio dos ativos em custódia do usuário
     */
    @Effect()
    public getCustodyAveragePrice$: Observable<AveragePriceAction> = this.actions$
        .pipe(
            ofType(AveragePriceAction.getCustodyAveragePrice),
            switchMap(() => {
                return this.averagePriceApiService.get('average-price/average-price')
                    .pipe(
                        map((result: any) => {
                            if (result) {
                                return { type: AveragePriceAction.getCustodyAveragePriceSuccess, payload: result };
                            }
                            return { type: AveragePriceAction.getCustodyAveragePriceError, payload: result };
                        }),
                        catchError((error) => {
                            return of({ type: AveragePriceAction.getCustodyAveragePriceError, payload: error });
                        }),
                    );
            }),
            share(),
        );

    constructor(
        private actions$: Actions<AveragePriceAction>,
        private averagePriceApiService: AveragePriceApiService
    ) {}
}
